// extracted by mini-css-extract-plugin
export var heading = "Text-module--heading--b9e09";
export var subHeading = "Text-module--subHeading--f5dd2";